export class SpriteConst {
}
SpriteConst.ALPHA = 0x01;
SpriteConst.TRANSFORM = 0x02;
SpriteConst.BLEND = 0x04;
SpriteConst.CANVAS = 0x08;
SpriteConst.FILTERS = 0x10;
SpriteConst.MASK = 0x20;
SpriteConst.CLIP = 0x40;
SpriteConst.TEXTURE = 0x80;
SpriteConst.GRAPHICS = 0x100;
SpriteConst.RENDERNODE2D = 0x200;
SpriteConst.CUSTOM = 0x400;
SpriteConst.HITAREA = 0x800;
SpriteConst.CHILDS = 0x1000;
SpriteConst.REPAINT_NONE = 0;
SpriteConst.REPAINT_NODE = 0x01;
SpriteConst.REPAINT_CACHE = 0x02;
SpriteConst.REPAINT_ALL = 0x03;
export var TransformKind;
(function (TransformKind) {
    TransformKind[TransformKind["Pos"] = 1] = "Pos";
    TransformKind[TransformKind["Width"] = 2] = "Width";
    TransformKind[TransformKind["Height"] = 4] = "Height";
    TransformKind[TransformKind["Anchor"] = 8] = "Anchor";
    TransformKind[TransformKind["Scale"] = 16] = "Scale";
    TransformKind[TransformKind["Skew"] = 32] = "Skew";
    TransformKind[TransformKind["Rotation"] = 64] = "Rotation";
    TransformKind[TransformKind["Matrix"] = 128] = "Matrix";
    TransformKind[TransformKind["Size"] = 6] = "Size";
    TransformKind[TransformKind["Layout"] = 30] = "Layout";
    TransformKind[TransformKind["TRS"] = 81] = "TRS";
})(TransformKind || (TransformKind = {}));
